module.exports = __webpack_public_path__ + "img/new-contact.25031965.svg";